import { useEffect } from "react";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import Nav from "@/components/site/Nav";
import Hero from "@/components/site/Hero";
import Marquee from "@/components/site/Marquee";
import Plan from "@/components/site/Plan";
import CustomWork from "@/components/site/CustomWork";
import HowItWorks from "@/components/site/HowItWorks";
import WhyLocal from "@/components/site/WhyLocal";
import Faq from "@/components/site/Faq";
import Reviews from "@/components/site/Reviews";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";
import MobileCallBar from "@/components/site/MobileCallBar";
import "@/App.css";

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.__lenis = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div className="bg-[#faf7f2] text-[#16324a] font-sans antialiased pb-[84px] md:pb-0">
      <Nav />
      <main>
        <Hero />
        <Marquee />
        <Plan />
        <CustomWork />
        <HowItWorks />
        <WhyLocal />
        <Faq />
        <Reviews />
        <Contact />
      </main>
      <Footer />
      <MobileCallBar />
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
